import React from "react";
import { useIntl } from "react-intl";
import { Button, Card, Select, Row } from "@masterteam/mt-design-react";

import { ReactComponent as PermissionsIcon } from "../../../../assets/images/permissions.svg";

import "./style.scss";

const PermissionsList = ({ items, onChange, loading, disabled }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";

  if (!items || !items.length) {
    return null;
  }

  const handleChange = (role, index) => {
    const _items = [...items];
    _items[index].Role = role;
    onChange(_items);
  };

  const options = {
    screen: [
      {
        ID: 1,
        Role: "View",
        RoleAr: "مشاهدة"
      }
    ],
    normal: [
      {
        ID: 1,
        Role: "View",
        RoleAr: "مشاهدة"
      },
      {
        ID: 2,
        Role: "View + Access",
        RoleAr: "مشاهدة + تنفيذ"
      }
    ],
    form: [
      {
        ID: 2,
        Role: "View + Access",
        RoleAr: "مشاهدة + تنفيذ"
      }
    ]
  };

  return (
    <div>
      <Button
        variant="secondary"
        loading={loading}
        type="button"
        className="cursor permisssions-btn"
        disabled={disabled}
        Icon={PermissionsIcon}
      >
        {intl.formatMessage({ id: "common.permissions" })}
      </Button>
      <div className="permissions-ul-container" tabIndex="1">
        <Card className="permissions-list">
          <Row align="center" className="permission-header">
            {intl.formatMessage({ id: "group.permission-matrix" })}
          </Row>
          {items.map((item, index) => {
            let _options = [];
            if (item.IsForm) _options = options.form;
            else _options = item.IsScreen ? options.screen : options.normal;

            return (
              <Row
                justify="between"
                align="center"
                key={item.ID}
                className="permission-row"
              >
                <div className="name">{item.Name}</div>
                <div
                  style={{
                    width: 200
                  }}
                >
                  <Select
                    style={{
                      height: 30
                    }}
                    value={_options.find((opt) => opt.ID === item.Role?.ID)}
                    getOptionLabel={(item) => (isAr ? item.RoleAr : item.Role)}
                    getOptionValue={(item) => item.ID}
                    onChange={(item) => handleChange(item, index)}
                    isClearable
                    menuPlacement={
                      index === items?.length - 1 ? "top" : "bottom"
                    }
                    options={_options}
                  />
                </div>
              </Row>
            );
          })}
        </Card>
      </div>
    </div>
  );
};

export default PermissionsList;
